"use strict";

var Spinner = require("../client/Spinner");

var BootstrapPrompt = require("../shared/BootstrapPrompt");

var SubmitButtonHelper = {
	//Utility methods for getting post-submit action values
	getPostSubmitActionData: function (componentSelector) {
		var $submitButton = $(`${componentSelector} form [data-component='submitButton']`);

		return {
			confirmationMessage: $submitButton.attr("data-success-message"),
			navUrl: $submitButton.attr("data-url"),
			postSubmitAction: $submitButton.attr("data-submit-action"),
			returnToReferrer: !!$submitButton.attr("data-return-to-referrer"),
			shouldRefreshPageOnSubmit: !!$submitButton.attr("data-should-refresh-page-on-submit")
		};
	},

	performPostSubmitAction: function (componentSelector, options) {
		options = options || {};

		var actionData = options.actionData || this.getPostSubmitActionData(componentSelector);

		var onNoPostSubmitAction = options.onNoPostSubmitAction;
		var onNoStayMessage = options.onNoStayMessage;
		var onStayMessage = options.onStayMessage;
		var shouldForceReloadOnStay = options.shouldForceReloadOnStay || actionData.shouldRefreshPageOnSubmit;

		if (actionData.postSubmitAction === undefined) {
			//No post action is defined
			if (typeof onNoPostSubmitAction === "function") {
				onNoPostSubmitAction();
			}

			if (shouldForceReloadOnStay) {
				window.location.reload();
			} else {
				Spinner.removeSpinner();
			}
		} else if (actionData.postSubmitAction === "stay" && actionData.confirmationMessage && actionData.confirmationMessage.trim() !== "") {
			if (typeof onStayMessage === "function") {
				onStayMessage(actionData.confirmationMessage, () => {
					if (shouldForceReloadOnStay) {
						window.location.reload();
					} else {
						Spinner.removeSpinner();
					}
				});
			} else {
				//Stay and show message
				BootstrapPrompt.success(actionData.confirmationMessage, () => {
					if (shouldForceReloadOnStay) {
						window.location.reload();
					} else {
						Spinner.removeSpinner();
					}
				});
			}
		} else if (actionData.postSubmitAction === "stay") {
			//Stay with no message
			if (typeof onNoStayMessage === "function") {
				onNoStayMessage();
			}

			if (shouldForceReloadOnStay) {
				window.location.reload();
			} else {
				Spinner.removeSpinner();
			}
		} else if (actionData.postSubmitAction === "goToPage" || actionData.postSubmitAction === "goToUrl") {
			//Go to Page or Url, leave Spinner in place until page refreshes.
			window.location = actionData.navUrl;
		}
	}
};

module.exports = SubmitButtonHelper;